import { toDisplayString as _toDisplayString, createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, Fragment as _Fragment } from "vue"

const _hoisted_1 = { class: "text-14px font-medium text-gray-lp-300 text-center" }
const _hoisted_2 = {
  key: 0,
  class: "flex flex-row gap-2 justify-center items-center"
}
const _hoisted_3 = { class: "font-bold text-14px text-gray-lp-600" }
const _hoisted_4 = {
  key: 1,
  class: "flex flex-row gap-3 justify-center"
}
const _hoisted_5 = { class: "w-10 h-10 flex items-center rounded-full bg-gray-lp-200" }
const _hoisted_6 = { class: "w-10 h-10 flex items-center rounded-full bg-gray-lp-200" }
const _hoisted_7 = { class: "w-10 h-10 flex items-center rounded-full bg-gray-lp-200" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_ModalTicketReview = _resolveComponent("ModalTicketReview")!

  return (_openBlock(), _createBlock(_Fragment, null, [
    _createVNode("div", {
      class: ["flex flex-col shadow-outer rounded-xl py-2 px-3 justify-center self-center mt-1", 
      `${
        _ctx.reviewType || _ctx.isExpiredReview
          ? 'gap-1 cursor-default'
          : 'gap-2 cursor-pointer'
      }`
    ],
      onClick: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.onClickReview && _ctx.onClickReview(...args)))
    }, [
      _createVNode("div", _hoisted_1, _toDisplayString(_ctx.reviewType
          ? _ctx.$t('pusatResolusi.review.rating')
          : _ctx.isExpiredReview
          ? _ctx.$t('pusatResolusi.review.timeLimit')
          : _ctx.$t('pusatResolusi.review.giveusrating')), 1),
      (_ctx.reviewType)
        ? (_openBlock(), _createBlock("div", _hoisted_2, [
            _createVNode("div", {
              class: ["w-8 h-8 flex items-center rounded-full", `${_ctx.reviewTypeImage.imageBackground}`],
              style: {"min-width":"32px"}
            }, [
              _createVNode("img", {
                src: _ctx.reviewTypeImage.image,
                class: "w-4 h-4 block m-auto",
                alt: "thumb-good"
              }, null, 8, ["src"])
            ], 2),
            _createVNode("div", _hoisted_3, _toDisplayString(_ctx.reviewMessage), 1)
          ]))
        : (_openBlock(), _createBlock("div", _hoisted_4, [
            _createVNode("div", _hoisted_5, [
              _createVNode("img", {
                src: 
            require(`@/app/ui/assets/svg/ics_f_thumb-good${
              _ctx.isExpiredReview ? '-disabled' : ''
            }.svg`)
          ,
                class: " w-6 h-6 block m-auto",
                alt: "thumb-good"
              }, null, 8, ["src"])
            ]),
            _createVNode("div", _hoisted_6, [
              _createVNode("img", {
                src: 
            require(`@/app/ui/assets/svg/ics_f_thumb-neutral${
              _ctx.isExpiredReview ? '-disabled' : ''
            }.svg`)
          ,
                class: " w-6 h-6 block m-auto",
                alt: "thumb-neutral"
              }, null, 8, ["src"])
            ]),
            _createVNode("div", _hoisted_7, [
              _createVNode("img", {
                src: 
            require(`@/app/ui/assets/svg/ics_f_thumb-bad${
              _ctx.isExpiredReview ? '-disabled' : ''
            }.svg`)
          ,
                class: " w-6 h-6 block m-auto",
                alt: "thumb-bad"
              }, null, 8, ["src"])
            ])
          ]))
    ], 2),
    _createVNode(_component_ModalTicketReview, {
      modelValue: _ctx.showModalReview,
      "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => (_ctx.showModalReview = $event)),
      reviewType: _ctx.reviewType,
      ticketId: _ctx.ticketId,
      ticketNo: _ctx.caseNumber,
      onClose: _ctx.onClickReview,
      onSuccess: _ctx.onSuccessReview
    }, null, 8, ["modelValue", "reviewType", "ticketId", "ticketNo", "onClose", "onSuccess"])
  ], 64))
}